import {
  Card,
  Grid,
  ListSubheader,
  MenuItem,
  Select,
  TextField,
  Typography,
  Button,
  RadioGroup,
  FormControlLabel,
  Radio,
  Divider,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  Container,
  TextareaAutosize
} from '@mui/material';
import React, { Fragment, useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { DateRangePicker } from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import RejectReasonForm from './RejectReasonForm';
import LeaveHistoryModal from './LeaveHistoryModal';
import NoPayProjectAllocationRow from './NoPayProjectAllocationRow';
import {
  approveLieuLeave,
  rejectLieuLeave,
  getLeaveHistoryById,
  approveLeave,
  rejectLeave,
  approveCancelLeave,
  rejectCancelLeave,
  getCalenderDataByEmployeeId
} from 'src/services/leaveService';
import ConfirmationModal from '../common/confirmationModal/ConfirmationModal';
import { useAppSelector } from 'src/hooks/hooks';
import { AppActions } from 'src/store/AppReducer';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { RootStateType } from 'src/store/RootReducer';
import { TableHeaderCell } from 'src/components/TableHeaderCell';
import { TableColumnCell } from 'src/components/TableColumnCell';
import { withStyles } from '@mui/styles';
import { LeaveRequestDetails } from 'src/models/leave';
import { LeaveManagementActions } from 'src/store/LeaveManagementReducer';
import SnackBar from 'src/components/SnackBar/SnackBar';
import moment from 'moment';
import {
  getEmploymentType,
  isCancellationRequest
} from './utils/cancellationUtils';
import NoAccessPopup from './NoAccessPopup';

const ViewLeave: React.FC = () => {
  const { id } = useParams();
  const appUser = useSelector((state: RootStateType) => state.appReducer.user);
  const employeeId = useSelector(
    (state: RootStateType) => state.appReducer?.user?.EmployeeId
  );
  const dispatch = useDispatch();
  const loggedUserName = useSelector(
    (state: RootStateType) => state.appReducer?.user?.Name
  );
  const myRef = useRef<DateRangePicker>();
  const [dateType, setDateType] = React.useState('full');

  const { handleSubmit } = useForm<any>();

  const navigate = useNavigate();

  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };

  let query = useQuery();

  const [openRejectReason, setOpenRejectReason] = useState(false);
  const [openLeaveHistory, setOpenLeaveHistory] = useState(false);

  const { isLoading } = useAppSelector((state) => state.appReducer);
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [leaveRequestDetails, setLeaveRequestDetails] =
    useState<LeaveRequestDetails>({
      id: '',
      status: '',
      coveringEmployee: '',
      attachment: '',
      fromDate: '',
      toDate: '',
      leaveRequestDate: '',
      halfDayType: null,
      leaveType: '',
      numberOfDays: 0,
      reason: '',
      reportingManager: '',
      totalLeaveAvailable: '',
      attachmentName: '',
      dateType: null,
      isEligible: null,
      employeeDetailsDto: {},
      projectLeadName: '',
      projectName: '',
      createdDate: '',
      rejectReason: ''
    });

  const [resource, setResource] = useState<any>();
  const [isQueryParam, setIsQueryParam] = useState<string>('');

  const [snackBarOpen, setSnackBarOpen] = useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = useState('');
  const [snackBarMessage, setSnackBarMessage] = useState('');

  const [calenderData, setCalenderData] = useState([]);
  const [selectEmployeeName, setSelectEmployeeName] = useState('');
  const [isLeaveData, setIsLeaveData] = useState(false);
  const [employeeLeavesId, setEmployeeLeavesId] = useState('');
  const [mainProjectManager, setMainProjectManager] = useState<any>();
  const [unauthorized, SetUnauthorized] = useState(false);

  useEffect(() => {
    const queryParam = query.get('name');
    if(queryParam.includes("?")) {
      const splitValues = queryParam.split("?");
      setIsQueryParam(splitValues[0]);
      setEmployeeLeavesId(splitValues[1]);
    }else{
      setIsQueryParam(queryParam);
    }
  }, []);

  const TextFieldStyle = {
    paddingTop: 4,
    paddingLeft: 15,
    paddingRight: 15,
    fontSize: '13px'
  };

  const dateStyle = {
    paddingTop: 4,
    paddingLeft: 15,
    fontSize: '13px'
  };

  const LabelStyle = {
    paddingLeft: 15,
    paddingRight: 15,
    fontSize: '13px'
  };

  const handleHistoryClose = () => {
    setOpenLeaveHistory(false);
  };

  const handleReasonClose = () => {
    setOpenRejectReason(false);
  };

  const handleReject = () => {
    setOpenRejectReason(false);
  };

  const validateComfirmation = () => {
    setOpenConfirmation(!openConfirmation);
  };

  const isNoPayLeaveType =
    leaveRequestDetails?.leaveType === 'No Pay Leave';

  const validateStatus = () => {
    if (isNoPayLeaveType) {
      switch (leaveRequestDetails?.status) {
        case 'PENDING':
          return 'Pending';
        case 'HR_APPROVED':
          return 'HR Manager Approved';
        case 'HR_REJECTED':
          return 'HR Manager Rejected';
        case 'CANCELLATION_REQUESTED':
          return 'Cancellation Requested';
        case 'CANCELLATION_REJECTED':
          return 'Cancellation Rejected';
        case 'CANCELLED':
          return 'Cancelled';
        default:
          return null;
      }
    }
    switch (leaveRequestDetails?.status) {
      case 'PENDING':
        return 'Pending';
      case 'RM_APPROVED':
        return 'PM/RM Approved';
      case 'HR_APPROVED':
        return 'HR Approved';
      case 'HR_REJECTED':
        return 'HR Rejected';
      case 'RM_REJECTED':
        return 'PM/RM Rejected';
      case 'CANCELLATION_REQUESTED':
        return 'Cancellation Requested';
      case 'CANCELLATION_REJECTED':
        return 'Cancellation Rejected';
      case 'CANCELLED':
        return 'Cancelled';
      default:
        return null;
    }
  };

  //reject lieuLeave request
  const onRejectLieuLeave = (rejectReason) => {
    dispatch(AppActions.showLoader());
    const data = {
      rejectReason: rejectReason
    };
    rejectLieuLeave(
      id,
      data,
      (getEmploymentType(leaveRequestDetails) || '').toUpperCase()
    )
      .then((res) => {
        dispatch(AppActions.hideLoader());
        setSnackBarMessage(res.data.message);
        setSnackbarSeverity('success');
        setSnackBarOpen(true);
        handleReject();
      })
      .catch((e) => {
        dispatch(AppActions.hideLoader());
        setSnackBarMessage(
          e?.response?.data?.message
            ? e.response.data.message
            : 'Unable to reject leave.'
        );
        setSnackbarSeverity('error');
        setSnackBarOpen(true);
        handleReject();
      });
  };

  //reject pending leave , RM approved request, work from home, and cancellation request
  const onRejectLeave = (rejectReason) => {
    dispatch(AppActions.showLoader());
    const data = {
      rejectReason: rejectReason
    };
    const isCancellationPending = isCancellationRequest(leaveRequestDetails);
    const empType = (getEmploymentType(leaveRequestDetails) || '').toUpperCase();
    const rejectCall = isCancellationPending
      ? rejectCancelLeave(
          id,
          data,
          loggedUserName,
          empType
        )
      : rejectLeave(
          id,
          data,
          loggedUserName,
          empType
        );
    rejectCall
      .then((res) => {
        dispatch(AppActions.hideLoader());
        setSnackBarMessage(
          isCancellationPending
            ? 'You have rejected the cancellation successfully.'
            : leaveRequestDetails?.leaveType === 'Work From Home'
            ? `You have rejected the work from home request successfully.`
            : 'You have rejected the leave successfully.'
        );
        setSnackbarSeverity('success');
        setSnackBarOpen(true);
        handleReject();
      })
      .catch((e) => {
        dispatch(AppActions.hideLoader());
        setSnackBarMessage(
          e?.response?.data?.message
            ? e.response.data.message
            : 'Unable to reject leave.'
        );
        setSnackbarSeverity('error');
        setSnackBarOpen(true);
        handleReject();
      });
  };

  //approve lieu leave request
  const onApproveLieuLeave = (requestId, employmentType) => {
    dispatch(AppActions.showLoader());
    approveLieuLeave(requestId, (employmentType || '').toUpperCase())
      .then((res) => {
        dispatch(AppActions.hideLoader());
        setSnackBarMessage(
          'You have approved the eligibility request successfully.'
        );
        setSnackbarSeverity('success');
        setSnackBarOpen(true);
        setOpenConfirmation(false);
      })
      .catch((err) => {
        dispatch(AppActions.hideLoader());
        setSnackBarMessage(
          err?.response?.data?.message
            ? err.response.data.message
            : 'Unable to approve leave.'
        );
        setSnackbarSeverity('error');
        setSnackBarOpen(true);
        setOpenConfirmation(false);
      });
  };

  //approve pending leave , RM approved leave request, work from home, and cancellation request
  const onApproveLeave = (requestId, employmentType) => {
    dispatch(AppActions.showLoader());
    const isCancellationPending = isCancellationRequest(leaveRequestDetails);
    const empType = (
      employmentType || getEmploymentType(leaveRequestDetails) || ''
    ).toUpperCase();
    const approveCall = isCancellationPending
      ? approveCancelLeave(requestId, empType, loggedUserName)
      : approveLeave(requestId, empType, loggedUserName);
    approveCall
      .then((res) => {
        dispatch(AppActions.hideLoader());
        setSnackBarMessage(
          isCancellationPending
            ? 'You have approved the cancellation successfully.'
            : isQueryParam === 'pending'
            ? leaveRequestDetails?.leaveType === 'Work From Home'
            ? `You have approved the work from home request successfully.`
            : 'You have approved the leave successfully.'
            : 'You have approved the PM/RM approved request successfully.'
        );
        setSnackbarSeverity('success');
        setSnackBarOpen(true);
        setOpenConfirmation(false);
      })
      .catch((err) => {
        dispatch(AppActions.hideLoader());
        setSnackBarMessage(
          err?.response?.data?.message
            ? err.response.data.message
            : 'Unable to approve leave.'
        );
        setSnackbarSeverity('error');
        setSnackBarOpen(true);
        setOpenConfirmation(false);
      });
  };

  useEffect(() => {
    leaveHistory(id);
  }, [id]);

  //load leave history by id
  const leaveHistory = (leaveRequestId: string) => {
    dispatch(AppActions.showLoader());
    getLeaveHistoryById(leaveRequestId)
      .then((res) => {
        if (res.data.statusCode === 200) {
          if (
            query.get('name') === 'pending' ||
            query.get('name') === 'lieuLeave'
          ) {
            const loggedUser = JSON.parse(window.localStorage.getItem('user'));
            const leaveRequestorEmployeeId =
              res.data?.data?.employeeDetailsDto?.employeeId;
            if (loggedUser.EmployeeId === leaveRequestorEmployeeId) {
              setIsLeaveData(false);
              SetUnauthorized(true);
            } else {
              setLeaveRequestDetails(res.data?.data);
              setResource(res.data?.data?.projectDetails);
              projectManagerHandling(res.data?.data);
              setIsLeaveData(true);
            }
          } else {
            setLeaveRequestDetails(res.data?.data);
            setResource(res.data?.data?.projectDetails);
            projectManagerHandling(res.data?.data);
            setIsLeaveData(true);
          }
        }
        dispatch(AppActions.hideLoader());
       
      })
      .catch((e) => {
        setSnackBarMessage('Unable to retrieve leave history.');
        setSnackbarSeverity('error');
        setSnackBarOpen(true);
        setIsLeaveData(false);
        dispatch(AppActions.hideLoader());
      });
  };

  //validate approved and rejected date
  const validateCreatedDate = (status) => {
    if (
      status === 'APPROVED' ||
      status === 'HR_APPROVED' ||
      status === 'RM_APPROVED'
    ) {
      return 'Approved Date';
    } else if (status === 'HR_REJECTED' || status === 'RM_REJECTED') {
      return 'Rejected Date';
    } else {
      return '';
    }
  };

  // custom table row with different color
  const CustomTableRow = withStyles({
    root: {
      background: '#E6E9FF !important',
      height: '3.5rem'
    }
  })(TableRow);

  //set attachment image
  const attachmentsTypes = (attachment: any) => {
    const _extension =
      attachment?.substring(
        attachment.lastIndexOf('.') + 1,
        attachment.length
      ) || attachment;
    let url = process.env.PUBLIC_URL;

    if (_extension === 'pdf') {
      url += '/img/pdficon.png';
    } else if (_extension === 'xlsx') {
      url += '/img/excelsheet.jpg';
    } else if (_extension === 'docx') {
      url += '/img/wordicon.png';
    } else if (
      _extension === 'png' ||
      _extension === 'jpg' ||
      _extension === 'jpeg'
    ) {
      url += '/img/imageicon.png';
    } else {
      url += '/img/imageicon.png';
    }
    return url;
  };

  // set file type
  const findFileType = (s) =>
    s.toLowerCase() &&
    s.includes('.') &&
    s.substr(s.lastIndexOf('.') + 1).split(' ')[0];

  //get attachment
  const getAttachment = () => {
    let fileType = ''; //set file type
    if (findFileType(leaveRequestDetails?.attachmentName) === 'jpg') {
      fileType = 'image/jpg';
    } else if (findFileType(leaveRequestDetails?.attachmentName) === 'jpeg') {
      fileType = 'image/jpeg';
    } else if (findFileType(leaveRequestDetails?.attachmentName) === 'png') {
      fileType = 'image/png';
    } else if (findFileType(leaveRequestDetails?.attachmentName) === 'pdf') {
      fileType = 'application/pdf';
    } else if (findFileType(leaveRequestDetails?.attachmentName) === 'doc') {
      fileType = 'application/msword';
    } else if (findFileType(leaveRequestDetails?.attachmentName) === 'docx') {
      fileType =
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
    }

    const blob = b64toBlob(leaveRequestDetails?.attachment, fileType); // use the appropriate MIME type
    const imageUrl = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = imageUrl;
    link.setAttribute('download', leaveRequestDetails?.attachmentName);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(imageUrl);
  };

  //set b64Blob
  const b64toBlob = (b64Data, contentType = ' ', sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  };

  //set breadcrumbs
  const onBreadcrumbs = (selectedParam: string) => {
    if (selectedParam === 'history') {
      navigate(`/leave-management/my-leave-history/id`);
    } else if(selectedParam === 'employeeLeaves') {
      navigate(`/leave-management/my-leave-history/${employeeLeavesId}?name=${leaveRequestDetails?.employeeDetailsDto?.name}`);
    }else {
      dispatch(LeaveManagementActions.setIsClickedViewLeave(selectedParam));
      navigate(`/leave-management`);
    }
  };

  //get all calendar data by employeeId
  useEffect(() => {
    if (openLeaveHistory) {
      setSelectEmployeeName(leaveRequestDetails?.employeeDetailsDto?.name);
      getCalenderDataByEmployeeId(
        leaveRequestDetails.employeeDetailsDto.employeeId
      )
        .then((res) => {
          if (res?.data?.data.length > 0) {
            const getCalenderData = res.data.data.map((data) => {
              return {
                ...data,
                fromDate: moment(data.fromDate).format('MM-DD-YYYY'),
                toDate: moment(data.toDate).format('MM-DD-YYYY'),
                typeName: data.typeName,
                dateType: data.dateType,
                halfDayType: data.halfDayType,
                daysCount: data.daysCount,
                relevantMonth: moment(data.fromDate).format('MMM'),
                relevantYear: moment(data.fromDate).format('YYYY')
              };
            });

            const sortByFromDate = getCalenderData
              .map((obj) => {
                return { ...obj, fromDate: new Date(obj.fromDate) };
              })
              .sort((a, b) => a.fromDate - b.fromDate);

            setCalenderData(sortByFromDate);
          }
        })
        .catch((e) => {});
    }
  }, [openLeaveHistory]);

  const handleChildPropData = (data) => {
    if (data) {
      onBreadcrumbs(isQueryParam);
    }
  };

  const projectManagerHandling = (resourceRes: any) => {
    let approvedProjectManager = resourceRes?.reportingManager;
    if (resourceRes?.projectDetails?.allocations?.length > 0) {
      let selectedProjectManager = null;

      resourceRes.projectDetails.allocations.forEach((element: any) => {
        if(element.projectManager === approvedProjectManager) {
          selectedProjectManager = element;
          if (element.type === 'Billable') {
            if (element.allocation > selectedProjectManager.allocation &&
              selectedProjectManager.type === 'Billable'
            ) {
              selectedProjectManager = element;
            } else if (
              element.allocation > selectedProjectManager.allocation &&
              selectedProjectManager.type !== 'Billable'
            ) {
              selectedProjectManager = element;
            }
          }
          setMainProjectManager(element);
        }
      });
      setMainProjectManager(selectedProjectManager);
    } else {
      setMainProjectManager(null);
    }
  };

  const validateProjectManager = (projectManagerId: string) => {
    if (isNoPayLeaveType) {
      return undefined;
    }
    if(projectManagerId) {
      if(projectManagerId === mainProjectManager?.projectManagerId) {
        return '#FFC300';
      }
    }
  }

  return (
    <Fragment>
      <Container
        maxWidth="xl"
        sx={{ padding: 2}}
      >
        <Grid spacing={4}>
          <Grid
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              marginRight: '2rem',
              alignItems: 'center'
            }}
          >
            <Grid sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
              <Grid container direction={'row'} sx={{ mb: '1rem' }}>
                <Grid item>
                  <Typography
                    onClick={() => {
                      navigate('/leave-management');
                    }}
                    style={{ cursor: 'pointer' }}
                    variant="h4"
                    component="h4"
                  >
                    Leave Management
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography
                    style={{ fontWeight: 'normal', cursor: 'pointer' }}
                    variant="h4"
                    component="h4"
                    onClick={() => {
                      onBreadcrumbs(isQueryParam);
                    }}
                  >
                    {isQueryParam === 'pending'
                      ? '/ Pending /'
                      : isQueryParam === 'lieuLeave'
                      ? '/ Lieu Leave Eligibility /'
                      : isQueryParam === 'rmApproved'
                      ? '/ PM/RM Approved /'
                      : isQueryParam === 'approved'
                      ? '/ Approved /'
                      : isQueryParam === 'rejected'
                      ? '/ Rejected /'
                      : isQueryParam === 'history'
                      ? '/ History /'
                      : isQueryParam === 'employeeLeaves' 
                      ? '/ Employee leaves history /' 
                      : ''}
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography
                    style={{ fontWeight: 'normal' }}
                    variant="h4"
                    component="h4"
                  >
                    {leaveRequestDetails?.employeeDetailsDto?.name}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid container sx={{ mb: 2 }} justifyContent="space-between">
            <Card
              style={{
                padding: '1rem',
              }}
            >
              <Grid item style={{ paddingBottom: '1rem' }}>
                <Typography
                  style={{ fontSize: '12px', paddingLeft: '15px' }}
                  variant="h3"
                >
                  {''}
                </Typography>
              </Grid>
              {isQueryParam === 'lieuLeave' && (
                <Grid item style={{ paddingBottom: '1rem' }}>
                  <Typography
                    style={{ fontSize: '15px', paddingLeft: '15px' }}
                    variant="h3"
                  >
                    Lieu Leave Application
                  </Typography>
                </Grid>
              )}
              <form>
                {isQueryParam !== 'lieuLeave' && (
                  <Grid container spacing={2} sx={{ paddingBottom: '1rem' }}>
                    <Grid item xs={4}>
                      <Typography
                        style={LabelStyle}
                        fontWeight="light"
                        variant="h5"
                      >
                        Leave Type
                      </Typography>
                      <TextField
                        inputProps={{ maxLength: 30 }}
                        size="small"
                        style={TextFieldStyle}
                        fullWidth
                        placeholder="Enter Leave Type"
                        variant="outlined"
                        value={
                          leaveRequestDetails.isEligible &&
                          leaveRequestDetails?.leaveType === 'Lieu Leave'
                            ? 'Lieu Leave Eligibility'
                            : leaveRequestDetails?.leaveType
                            ? leaveRequestDetails.leaveType
                            : '---'
                        }
                        disabled={true}
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <Typography
                        style={LabelStyle}
                        fontWeight="light"
                        variant="h5"
                      >
                        Day Type
                      </Typography>
                      <TextField
                        inputProps={{ maxLength: 30 }}
                        size="small"
                        style={TextFieldStyle}
                        fullWidth
                        placeholder="Enter Date Type"
                        variant="outlined"
                        disabled={true}
                        value={
                          leaveRequestDetails?.leaveType === 'Short Leave'
                            ? 'N/A'
                            : leaveRequestDetails.dateType
                            ? 'Full Day'
                            : leaveRequestDetails.dateType === false
                            ? 'Half Day'
                            : '---'
                        }
                      />
                    </Grid>
                    {isQueryParam === 'history' &&
                      leaveRequestDetails.dateType === false && (
                        <Grid item xs={4}>
                          <Typography
                            style={LabelStyle}
                            fontWeight="light"
                            variant="h5"
                          >
                          {`${
                               leaveRequestDetails?.leaveType === 'Short Leave'
                                ? 'Short Leave Type'
                                : 'Half Day Type'
                            }`}
                          </Typography>
                          <TextField
                            inputProps={{ maxLength: 30 }}
                            size="small"
                            style={TextFieldStyle}
                            fullWidth
                            placeholder="Enter Date Type"
                            variant="outlined"
                            disabled={true}
                            value={
                              leaveRequestDetails.halfDayType
                                ? 'Morning'
                                : leaveRequestDetails.halfDayType === false
                                ? 'Evening'
                                : '---'
                            }
                          />
                        </Grid>
                      )}
                    <Grid item xs={4}>
                      <Typography
                        style={LabelStyle}
                        fontWeight="light"
                        variant="h5"
                      >
                        Covering Employee
                      </Typography>
                      <TextField
                        inputProps={{ maxLength: 30 }}
                        size="small"
                        style={TextFieldStyle}
                        fullWidth
                        placeholder="Enter Covering Employee"
                        variant="outlined"
                        disabled={true}
                        value={
                          leaveRequestDetails?.coveringEmployee
                            ? leaveRequestDetails.coveringEmployee
                            : '---'
                        }
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <Typography
                        style={LabelStyle}
                        fontWeight="light"
                        variant="h5"
                      >
                        From
                      </Typography>
                      <TextField
                        inputProps={{ maxLength: 30 }}
                        size="small"
                        style={TextFieldStyle}
                        fullWidth
                        placeholder="Enter From Date"
                        variant="outlined"
                        disabled={true}
                        value={
                          leaveRequestDetails?.fromDate
                            ? leaveRequestDetails.fromDate
                            : '---'
                        }
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <Typography
                        style={LabelStyle}
                        fontWeight="light"
                        variant="h5"
                      >
                        To
                      </Typography>
                      <TextField
                        inputProps={{ maxLength: 30 }}
                        size="small"
                        style={TextFieldStyle}
                        fullWidth
                        placeholder="Enter To Date"
                        variant="outlined"
                        disabled={true}
                        value={
                          leaveRequestDetails?.toDate
                            ? leaveRequestDetails.toDate
                            : '---'
                        }
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <Typography
                        style={LabelStyle}
                        fontWeight="light"
                        variant="h5"
                      >
                        Days Count
                      </Typography>
                      <TextField
                        inputProps={{ maxLength: 30 }}
                        size="small"
                        style={TextFieldStyle}
                        fullWidth
                        placeholder="Enter Days Count"
                        variant="outlined"
                        disabled={true}
                        value={
                          leaveRequestDetails?.numberOfDays
                            ? leaveRequestDetails.numberOfDays
                            : '---'
                        }
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <Typography
                        style={LabelStyle}
                        fontWeight="light"
                        variant="h5"
                      >
                        Attachment
                      </Typography>
                      <Grid item display="flex" style={{ marginTop: 5 }}>
                        {leaveRequestDetails.attachmentName ? (
                          <>
                            <img
                              src={attachmentsTypes(
                                leaveRequestDetails?.attachmentName
                              )}
                              style={{
                                width: '32px',
                                height: '32px',
                                marginLeft: 15
                              }}
                              alt=""
                            />
                            <span
                              onClick={getAttachment}
                              style={{
                                fontSize: '12px',
                                cursor: 'pointer',
                                marginTop: 5,
                                marginLeft: 4
                              }}
                            >{`${
                              leaveRequestDetails?.attachmentName
                                ? leaveRequestDetails.attachmentName
                                : 'No Selected File'
                            }`}</span>
                          </>
                        ) : (
                          <TextField
                            inputProps={{ maxLength: 30 }}
                            size="small"
                            style={TextFieldStyle}
                            fullWidth
                            placeholder="No Selected File"
                            variant="outlined"
                            disabled={true}
                          />
                        )}
                        &nbsp;
                      </Grid>
                    </Grid>
                    <Grid item xs={4}>
                      <Typography
                        style={LabelStyle}
                        fontWeight="light"
                        variant="h5"
                      >
                        PM/RM
                      </Typography>
                      <TextField
                        inputProps={{ maxLength: 30 }}
                        size="small"
                        style={TextFieldStyle}
                        fullWidth
                        placeholder="Enter Reporting Manager"
                        variant="outlined"
                        disabled={true}
                        value={
                          leaveRequestDetails?.reportingManager
                            ? leaveRequestDetails.reportingManager
                            : '---'
                        }
                      />
                    </Grid>
                    {isQueryParam !== 'history' ? (
                      <Grid item xs={4}>
                        <Typography
                          style={LabelStyle}
                          fontWeight="light"
                          variant="h5"
                        >
                          Status
                        </Typography>
                        <TextField
                          inputProps={{ maxLength: 30 }}
                          size="small"
                          style={TextFieldStyle}
                          fullWidth
                          placeholder="Enter Status"
                          variant="outlined"
                          disabled={true}
                          value={validateStatus() ? validateStatus() : '---'}
                        />
                      </Grid>
                    ) : (
                      <>
                        {(validateCreatedDate(leaveRequestDetails.status) ===
                          'Approved Date' ||
                          validateCreatedDate(leaveRequestDetails.status) ===
                            'Rejected Date') && (
                          <Grid item xs={4}>
                            <Typography
                              style={LabelStyle}
                              fontWeight="light"
                              variant="h5"
                            >
                              {validateCreatedDate(leaveRequestDetails.status)
                                ? validateCreatedDate(
                                    leaveRequestDetails.status
                                  )
                                : '---'}
                            </Typography>
                            <TextField
                              inputProps={{ maxLength: 30 }}
                              size="small"
                              style={TextFieldStyle}
                              fullWidth
                              placeholder="Enter Status"
                              variant="outlined"
                              disabled={true}
                              value={
                                leaveRequestDetails?.createdDate
                                  ? moment(
                                      leaveRequestDetails.createdDate
                                    ).format('D MMM YYYY')
                                  : leaveRequestDetails?.createdDate
                                  ? moment(
                                      leaveRequestDetails.createdDate
                                    ).format('D MMM YYYY')
                                  : '---'
                              }
                            />
                          </Grid>
                        )}
                      </>
                    )}
                    <Grid item xs={12}>
                      <Typography
                        style={LabelStyle}
                        fontWeight="light"
                        variant="h5"
                      >
                        Reason (Optional)
                      </Typography>
                      <TextField
                        size="small"
                        multiline
                        rows={3}
                        className="input-text"
                        style={TextFieldStyle}
                        inputProps={{
                          style: {
                            fontSize: '13px'
                          }
                        }}
                        fullWidth
                        placeholder="Enter Reason"
                        variant="outlined"
                        disabled={true}
                        value={
                          leaveRequestDetails?.reason
                            ? leaveRequestDetails.reason
                            : '---'
                        }
                      />
                    </Grid>
                    {leaveRequestDetails?.cancelReason && (
                      <Grid item xs={12} sx={{ mt: 2 }}>
                        <Typography
                          style={LabelStyle}
                          fontWeight="light"
                          variant="h5"
                        >
                          Cancel Reason
                        </Typography>
                        <TextField
                          size="small"
                          multiline
                          rows={3}
                          className="input-text"
                          style={TextFieldStyle}
                          inputProps={{
                            style: {
                              fontSize: '13px'
                            }
                          }}
                          fullWidth
                          placeholder="Cancel Reason"
                          variant="outlined"
                          disabled={true}
                          value={leaveRequestDetails.cancelReason}
                        />
                      </Grid>
                    )}
                    {!leaveRequestDetails.isEligible && (<>
                      <Grid
                      item xs={12}
                      style={{ paddingBottom: '1rem', paddingTop: '2rem' }}
                    >
                      <div
                        style={{
                          paddingLeft: '15px',
                          paddingRight: '15px',
                          display: 'flex',
                          justifyContent: 'space-between'
                        }}
                      >
                        <Typography variant="h3" style={{ fontSize: '12px' }}>
                          Project Allocation - Within The Leave Period
                        </Typography>
                        <div
                          style={{
                            display: 'flex',
                            gap: '10px',
                            alignItems: 'center'
                          }}
                        >
                          <div
                            style={{
                              background: '#FFC300',
                              borderRadius: '50%',
                              width: '7px',
                              height: '7px'
                            }}
                          ></div>
                          <Typography variant="h3" style={{ fontSize: '12px' }}>
                            Approver
                          </Typography>
                        </div>
                      </div>
                    </Grid>
                    <TableContainer className="tableContainer">
                      <Table
                        style={{ borderCollapse: 'separate' }}
                        size="small"
                      >
                        <TableHead>
                          <CustomTableRow>
                            <TableHeaderCell content="Project Name" smallFont />
                            <TableHeaderCell content="Type" smallFont />
                            <TableHeaderCell content="Allocation" smallFont />
                            <TableHeaderCell
                              content="Project Manager"
                              smallFont
                            />
                          </CustomTableRow>
                        </TableHead>
                        <TableBody>
                          {resource?.allocations?.map((item) => {
                            const approverDotColor = validateProjectManager(
                              item?.projectManagerId
                            );
                            return (
                              <TableRow hover key={item.projectId ?? item.projectName}>
                                <TableColumnCell>
                                  <Typography
                                    paddingBottom="0.25rem"
                                    paddingTop="0.5rem"
                                    variant="body2"
                                    style={{ fontSize: '11px' }}
                                    gutterBottom
                                    noWrap
                                  >
                                    {item.projectName}
                                  </Typography>
                                </TableColumnCell>
                                <TableColumnCell>
                                  <Typography
                                    paddingBottom="0.25rem"
                                    paddingTop="0.5rem"
                                    variant="body2"
                                    style={{ fontSize: '11px' }}
                                    gutterBottom
                                    noWrap
                                  >
                                    {item.type}
                                  </Typography>
                                </TableColumnCell>
                                <TableColumnCell>
                                  <Typography
                                    paddingBottom="0.25rem"
                                    paddingTop="0.5rem"
                                    variant="body2"
                                    style={{ fontSize: '11px' }}
                                    color="text.primary"
                                    gutterBottom
                                    noWrap
                                  >
                                    {item.allocation}%
                                  </Typography>
                                </TableColumnCell>
                                <TableColumnCell>
                                  <div
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: '10px'
                                    }}
                                  >
                                    <div
                                      style={{
                                        background: approverDotColor,
                                        borderRadius: '50%',
                                        width: '7px',
                                        height: '7px',
                                        flexShrink: 0
                                      }}
                                    ></div>
                                    <Typography
                                      paddingBottom="0.25rem"
                                      paddingTop="0.5rem"
                                      variant="body2"
                                      color="text.primary"
                                      gutterBottom
                                      noWrap
                                      style={{ fontSize: '11px' }}
                                    >
                                      {item?.projectManager
                                        ? item.projectManager
                                        : '-'}
                                    </Typography>
                                  </div>
                                </TableColumnCell>
                              </TableRow>
                            );
                          })}
                          {!isNoPayLeaveType &&
                            (!resource?.allocations ||
                              resource.allocations.length === 0) && (
                              <TableRow hover>
                                <TableColumnCell></TableColumnCell>
                                <TableColumnCell>
                                  <Typography
                                    paddingBottom="0.25rem"
                                    paddingTop="0.5rem"
                                    variant="body2"
                                    style={{ fontSize: '11px' }}
                                    gutterBottom
                                    noWrap
                                  >
                                    No Record Data
                                  </Typography>
                                </TableColumnCell>
                                <TableColumnCell></TableColumnCell>
                              </TableRow>
                            )}
                          {isNoPayLeaveType && (
                            <NoPayProjectAllocationRow
                              hrManagerName={
                                leaveRequestDetails?.hrManagerApprover
                              }
                            />
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                    </>)}
                  </Grid>
                )}
                {isQueryParam === 'lieuLeave' && (
                  <Grid container spacing={2} sx={{ paddingBottom: '1rem' }}>
                    <Grid item xs={4}>
                      <Typography
                        style={LabelStyle}
                        fontWeight="light"
                        variant="h5"
                      >
                        Day Type
                      </Typography>
                      <TextField
                        inputProps={{ maxLength: 30 }}
                        size="small"
                        style={TextFieldStyle}
                        fullWidth
                        placeholder="Enter Date Type"
                        variant="outlined"
                        disabled={true}
                        value={
                          leaveRequestDetails.dateType === true
                            ? 'Full Day'
                            : 'Half Day'
                        }
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <Typography
                        style={LabelStyle}
                        fontWeight="light"
                        variant="h5"
                      >
                        Extra Worked Days
                      </Typography>
                      <TextField
                        inputProps={{ maxLength: 30 }}
                        size="small"
                        style={TextFieldStyle}
                        fullWidth
                        placeholder="Enter Date Type"
                        variant="outlined"
                        disabled={true}
                        value={
                          leaveRequestDetails?.fromDate ===
                          leaveRequestDetails?.toDate
                            ? leaveRequestDetails?.fromDate
                            : `${leaveRequestDetails?.fromDate} - ${leaveRequestDetails?.toDate}`
                        }
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <Typography
                        style={LabelStyle}
                        fontWeight="light"
                        variant="h5"
                      >
                        Days Count
                      </Typography>
                      <TextField
                        inputProps={{ maxLength: 30 }}
                        size="small"
                        style={TextFieldStyle}
                        fullWidth
                        placeholder="Enter Covering Employee"
                        variant="outlined"
                        disabled={true}
                        value={
                          leaveRequestDetails?.numberOfDays
                            ? leaveRequestDetails?.numberOfDays
                            : '---'
                        }
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <Typography
                        style={LabelStyle}
                        fontWeight="light"
                        variant="h5"
                      >
                        Project Worked On
                      </Typography>
                      <TextField
                        inputProps={{ maxLength: 30 }}
                        size="small"
                        style={TextFieldStyle}
                        fullWidth
                        placeholder="Enter Leave Type"
                        variant="outlined"
                        value={
                          leaveRequestDetails.projectName
                            ? leaveRequestDetails.projectName
                            : '---'
                        }
                        disabled={true}
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <Typography
                        style={LabelStyle}
                        fontWeight="light"
                        variant="h5"
                      >
                        Project Lead
                      </Typography>
                      <TextField
                        inputProps={{ maxLength: 30 }}
                        size="small"
                        style={TextFieldStyle}
                        fullWidth
                        placeholder="Enter Leave Type"
                        variant="outlined"
                        value={
                          leaveRequestDetails?.projectLeadName
                            ? leaveRequestDetails?.projectLeadName
                            : '---'
                        }
                        disabled={true}
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <Typography
                        style={LabelStyle}
                        fontWeight="light"
                        variant="h5"
                      >
                        PM/RM
                      </Typography>
                      <TextField
                        inputProps={{ maxLength: 30 }}
                        size="small"
                        style={TextFieldStyle}
                        fullWidth
                        placeholder="Enter Covering Employee"
                        variant="outlined"
                        disabled={true}
                        value={
                          leaveRequestDetails?.reportingManager
                            ? leaveRequestDetails?.reportingManager
                            : '---'
                        }
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Typography
                        style={LabelStyle}
                        fontWeight="light"
                        variant="h5"
                      >
                        Additional Details (Option)
                      </Typography>
                      <TextField
                        size="small"
                        multiline
                        rows={3}
                        className="input-text"
                        style={TextFieldStyle}
                        inputProps={{
                          style: {
                            fontSize: '13px'
                          }
                        }}
                        fullWidth
                        placeholder="Enter Reason"
                        variant="outlined"
                        disabled={true}
                        value={
                          leaveRequestDetails?.reason
                            ? leaveRequestDetails?.reason
                            : '---'
                        }
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Grid
                        sx={{
                          paddingLeft: '15px',
                          paddingRight: '15px',
                          display: 'flex',
                          marginTop: '1rem'
                        }}
                      >
                        <span style={{ color: 'red' }}>*</span>
                        <Typography
                          style={LabelStyle}
                          fontWeight="light"
                          variant="h5"
                        >
                          To all staff who work a minimum of nine (09) hours on
                          a Sunday, Saturday or mercantile holiday, subject to
                          the prior approval by the Supervisor.
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid item xs={12}>
                      <Grid
                        sx={{
                          paddingLeft: '15px',
                          paddingRight: '15px',
                          display: 'flex'
                        }}
                      >
                        <span style={{ color: 'red' }}>*</span>
                        <Typography
                          style={LabelStyle}
                          fontWeight="light"
                          variant="h5"
                        >
                          Half a day of lieu leave is granted after four (04)
                          hours (but less than nine(09) hours) of work on a
                          Sunday, Saturday, or mercantile holiday.
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid item xs={12}>
                      <Grid
                        sx={{
                          paddingLeft: '15px',
                          paddingRight: '15px',
                          display: 'flex'
                        }}
                      >
                        <span style={{ color: 'red' }}>*</span>
                        <Typography
                          style={LabelStyle}
                          fontWeight="light"
                          variant="h5"
                        >
                          Interns / Trainees are not entitled to lieu leave.
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                )}
                {!(
                  isQueryParam === 'rejected' ||
                  isQueryParam === 'approved' ||
                  isQueryParam === 'history'
                ) && (
                  <>
                    {isLeaveData &&
                      leaveRequestDetails.employeeDetailsDto.employeeId !==
                        employeeId && (
                        <Grid
                          item
                          sx={{
                            mt: 4,
                            pr: 2,
                            display: 'flex',
                            justifyContent:
                              isQueryParam !== 'lieuLeave'
                                ? 'space-between'
                                : 'flex-end'
                          }}
                          xs={12}
                        >
                          {isQueryParam !== 'lieuLeave' && (
                            <Button
                              sx={{
                                ml: 2,
                                fontWeight: 'normal',
                                fontSize: '13px'
                              }}
                              style={{
                                backgroundColor: '#FFFFFF',
                                color: '#0069E4',
                                border: '1px solid #0069E4'
                              }}
                              onClick={(e) => {
                                setOpenLeaveHistory(true);
                              }}
                            >
                              Leave History
                            </Button>
                          )}
                          <LeaveHistoryModal
                            open={openLeaveHistory}
                            onClose={handleHistoryClose}
                            getData={calenderData}
                            getEmployeeName={selectEmployeeName}
                          />
                          <Grid
                            sx={{ display: 'flex', justifyContent: 'flex-end' }}
                          >
                            <Button
                              sx={{
                                width: '100px',
                                fontWeight: 'normal',
                                background: '#F5F7FF',
                                fontSize: '13px'
                              }}
                              style={{
                                backgroundColor: '#F8F2F2',
                                color: 'red'
                              }}
                              onClick={(e) => {
                                setOpenRejectReason(true);
                              }}
                            >
                              Reject
                            </Button>
                            <RejectReasonForm
                              open={openRejectReason}
                              onClose={handleReasonClose}
                              getData={(e) => {
                                isQueryParam === 'lieuLeave'
                                  ? onRejectLieuLeave(e.reason)
                                  : onRejectLeave(e.reason);
                              }}
                              navigationPath={isQueryParam}
                              leaveDetails={leaveRequestDetails}
                            />
                            <Button
                              sx={{
                                width: '100px',
                                ml: 2,
                                fontSize: '13px',
                                fontWeight: 'normal',
                                background: '#0069E4'
                              }}
                              variant="contained"
                              type="button"
                              onClick={() => validateComfirmation()}
                            >
                              Approve
                            </Button>
                          </Grid>
                        </Grid>
                      )}
                  </>
                )}
                {(isQueryParam === 'history' || isQueryParam === 'rejected') &&
                  leaveRequestDetails.rejectReason && (
                    <Grid item xs={12}>
                      <Typography
                        style={LabelStyle}
                        fontWeight="light"
                        variant="h5"
                        sx={{ marginTop: 2 }}
                      >
                        Reject Reason
                      </Typography>
                      <TextField
                        size="small"
                        multiline
                        rows={3}
                        className="input-text"
                        style={TextFieldStyle}
                        inputProps={{
                          style: {
                            fontSize: '13px'
                          }
                        }}
                        fullWidth
                        variant="outlined"
                        disabled={true}
                        value={
                          leaveRequestDetails?.rejectReason
                            ? leaveRequestDetails.rejectReason
                            : '---'
                        }
                      />
                    </Grid>
                  )}
                <ConfirmationModal
                  isLoading={isLoading}
                  open={openConfirmation}
                  toggle={validateComfirmation}
                  message={
                    isCancellationRequest(leaveRequestDetails)
                      ? `Are you sure you want to approve this cancellation request?`
                      : isQueryParam === 'lieuLeave'
                      ? ` Are you sure you want to approve this eligibility request?`
                      : isQueryParam === 'pending'
                      ? leaveRequestDetails?.leaveType === 'Work From Home'
                      ? `Are you sure you want to approve this work from home request?`
                      : `Are you sure you want to approve this leave?`
                      : `Are you sure you want to approve this PM/RM approved request?`
                  }
                  onConfirm={() => {
                    if (isCancellationRequest(leaveRequestDetails)) {
                      onApproveLeave(
                        leaveRequestDetails?.id,
                        getEmploymentType(leaveRequestDetails)
                      );
                    } else if (isQueryParam === 'lieuLeave') {
                      onApproveLieuLeave(
                        leaveRequestDetails?.id,
                        getEmploymentType(leaveRequestDetails)
                      );
                    } else {
                      onApproveLeave(
                        leaveRequestDetails?.id,
                        getEmploymentType(leaveRequestDetails)
                      );
                    }
                  }}
                  noToggle={validateComfirmation}
                />

                <NoAccessPopup
                  open={unauthorized}
                  message={`You do not have the required permissions to approve this request.`}
                />
              </form>
            </Card>
            <SnackBar
              snackBarOpen={snackBarOpen}
              setSnackBarOpen={setSnackBarOpen}
              snackBarMessage={snackBarMessage}
              snackbarSeverity={snackbarSeverity}
              isClickContinue={handleChildPropData}
            />
          </Grid>
        </Grid>
      </Container>
    </Fragment>
  );
};

export default ViewLeave;
